export const makeSignatureStamp = ({
  color = '#FF061B',
  width = '10rem',
  height = '10rem',
  className = '',
}) => `<?xml version="1.0" standalone="no"?>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    class="${className}"
    viewBox="0 0 488.000000 488.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,488.000000) scale(0.100000,-0.100000)"
      fill="${color}"
      stroke="none"
    >
      <path
        d="M1180 2410 l0 -1290 1290 0 1290 0 0 1290 0 1290 -1290 0 -1290 0 0
          -1290z m2495 0 l0 -1205 -1205 0 -1205 0 -3 1195 c-1 657 0 1201 3 1208 3 10
          250 12 1207 10 l1203 -3 0 -1205z"
      />
      <path
        d="M1364 3376 c-3 -8 -4 -23 -2 -33 3 -16 16 -18 111 -21 117 -3 120 -5
          87 -60 -29 -47 -81 -76 -172 -96 -23 -5 -28 -12 -28 -36 0 -28 3 -30 35 -30
          48 0 123 40 167 88 l36 40 39 -40 c44 -47 124 -88 171 -88 29 0 32 3 32 30 0
          24 -5 31 -27 35 -64 13 -108 31 -135 53 -28 24 -58 71 -58 91 0 6 43 11 108
          13 l107 3 0 30 0 30 -233 3 c-196 2 -233 0 -238 -12z"
      />
      <path
        d="M1964 3376 c-13 -34 0 -51 43 -54 l41 -3 -34 -50 c-18 -28 -38 -68
          -44 -89 -14 -50 -9 -675 5 -675 6 0 12 115 15 315 6 353 7 359 86 455 l38 45
          88 0 c84 0 88 -1 94 -23 3 -13 4 -41 2 -63 l-3 -39 -81 -5 c-46 -3 -88 -11
          -97 -18 -9 -8 -24 -34 -33 -58 -19 -51 -14 -132 11 -170 15 -23 20 -24 131
          -24 l115 0 -3 28 -3 27 -103 5 c-76 4 -105 9 -112 20 -15 23 -12 73 6 98 13
          20 24 22 94 22 75 0 81 1 97 27 28 42 30 150 4 201 l-21 42 -166 0 c-134 0
          -166 -3 -170 -14z"
      />
      <path
        d="M2417 3384 c-4 -4 -7 -119 -7 -256 0 -195 3 -249 13 -246 9 4 13 64
          15 248 2 223 -2 273 -21 254z"
      />
      <path
        d="M2547 3383 c-13 -13 -7 -134 8 -163 l16 -30 157 0 158 0 17 29 c11
          20 17 51 17 94 0 100 -30 101 -40 2 l-5 -50 -62 -3 -63 -3 0 48 c0 26 -4 54
          -9 62 -16 26 -31 0 -31 -55 l0 -54 -64 0 c-72 0 -76 5 -76 88 0 39 -8 51 -23
          35z"
      />
      <path
        d="M2997 3383 c-4 -3 -7 -203 -7 -444 0 -429 4 -481 31 -438 10 16 13
          848 3 873 -7 17 -16 20 -27 9z"
      />
      <path
        d="M3149 3364 l-24 -26 -3 -425 c-2 -342 0 -424 10 -421 10 4 14 91 18
          400 4 314 8 398 19 411 29 36 39 20 43 -72 4 -104 19 -131 74 -131 40 0 54
          -21 54 -77 0 -52 -17 -71 -65 -75 -37 -3 -41 -6 -53 -43 -23 -68 -10 -190 31
          -277 45 -97 114 -157 131 -112 12 32 5 54 -21 71 -70 45 -106 115 -107 208 -1
          67 0 70 24 73 49 6 79 24 89 54 17 49 14 172 -6 213 -15 31 -21 35 -54 35 -50
          0 -61 17 -57 87 l3 58 62 3 c52 2 63 6 68 23 13 39 -10 49 -114 49 -92 0 -99
          -2 -122 -26z"
      />
      <path
        d="M3475 3356 c-12 -29 -15 -108 -15 -451 0 -391 1 -416 18 -413 16 3
          17 28 20 321 l2 317 29 0 c40 0 41 -12 41 -352 0 -227 3 -289 13 -286 9 4 13
          81 15 333 3 371 2 375 -64 375 l-35 0 3 58 3 57 45 5 c42 5 45 7 45 35 0 29
          -1 30 -53 33 -52 3 -53 3 -67 -32z"
      />
      <path
        d="M2592 3034 c-37 -26 -52 -67 -52 -145 0 -121 41 -179 125 -179 l35 0
          0 -75 0 -75 -75 0 c-79 0 -98 -11 -88 -51 5 -18 19 -19 195 -19 l189 0 -3 33
          -3 32 -82 3 -83 3 0 74 0 75 50 0 c37 0 55 5 71 21 67 67 65 223 -3 296 -20
          21 -30 23 -138 23 -88 0 -121 -4 -138 -16z m267 -80 c30 -38 29 -119 -1 -151
          -20 -21 -30 -23 -128 -23 -100 0 -108 1 -130 25 -34 36 -39 111 -10 148 21 27
          23 27 135 27 111 0 114 -1 134 -26z"
      />
      <path
        d="M1387 2932 c-31 -34 -37 -74 -37 -235 0 -174 4 -207 26 -207 11 0 14
          34 14 184 0 145 3 186 14 195 9 8 43 11 93 9 l78 -3 5 -189 c4 -137 8 -190 17
          -193 10 -4 13 41 15 189 l3 193 90 0 90 0 6 -160 c4 -88 7 -177 8 -197 1 -27
          5 -38 17 -38 13 0 15 25 12 208 -3 179 -5 212 -21 235 l-17 27 -199 0 c-176 0
          -200 -2 -214 -18z"
      />
      <path
        d="M2067 2761 c-2 -10 0 -26 5 -35 8 -14 31 -16 168 -16 l159 0 7 -34
          c3 -21 1 -45 -8 -63 l-13 -28 -155 -5 -155 -5 0 -25 0 -25 168 -3 168 -2 14
          34 c17 41 20 178 5 207 -10 18 -23 19 -184 19 -161 0 -174 -1 -179 -19z"
      />
      <path
        d="M1364 2306 c-3 -8 -4 -23 -2 -33 3 -17 20 -18 206 -21 l202 -2 17
          -27 c16 -23 18 -57 21 -249 3 -180 1 -228 -12 -257 l-15 -36 -158 -3 -158 -3
          0 -30 0 -30 164 0 164 0 21 28 c20 27 21 42 24 305 3 271 2 278 -20 322 l-23
          45 -213 3 c-179 2 -213 0 -218 -12z"
      />
      <path
        d="M3124 2306 c-3 -8 -4 -23 -2 -33 3 -17 20 -18 206 -21 l202 -2 17
          -27 c16 -23 18 -57 21 -249 3 -180 1 -228 -12 -257 l-15 -36 -158 -3 -158 -3
          0 -30 0 -30 164 0 164 0 21 28 c20 27 21 42 24 305 3 271 2 278 -20 322 l-23
          45 -213 3 c-179 2 -213 0 -218 -12z"
      />
      <path
        d="M1967 2304 c-4 -4 -7 -20 -7 -36 0 -27 2 -28 50 -28 l51 0 -3 -72 -3
          -73 -45 -5 c-42 -5 -45 -7 -45 -35 l0 -30 235 0 235 0 0 30 c0 29 -2 30 -47
          33 l-48 3 0 74 0 74 48 3 c45 3 47 4 47 33 l0 30 -231 3 c-127 1 -233 -1 -237
          -4z m333 -139 l0 -76 -102 3 -103 3 -3 73 -3 72 106 0 105 0 0 -75z"
      />
      <path
        d="M2544 2296 c-3 -8 -4 -23 -2 -33 3 -16 17 -19 118 -23 l115 -5 3 -33
          c5 -54 -9 -62 -114 -62 -93 0 -93 0 -109 -30 -18 -35 -20 -138 -3 -175 15 -33
          31 -36 158 -33 l105 3 0 30 0 30 -113 3 c-108 3 -113 4 -124 27 -6 13 -8 35
          -4 49 6 26 8 26 101 26 84 0 96 2 114 22 37 39 41 141 7 193 -16 24 -20 25
          -132 25 -91 0 -116 -3 -120 -14z"
      />
      <path
        d="M2886 2295 c-9 -25 -7 -408 3 -424 20 -31 31 2 31 90 l0 89 35 0 35
          0 0 -321 c0 -252 3 -320 13 -317 16 6 18 888 2 888 -6 0 -12 -39 -15 -87 l-5
          -88 -30 0 -30 0 -5 89 c-5 85 -19 119 -34 81z"
      />
      <path
        d="M1381 2077 c-28 -58 -29 -155 -1 -212 19 -40 23 -43 73 -49 28 -3 89
          -6 134 -6 78 0 82 1 107 30 30 37 40 81 34 160 -3 40 -11 70 -25 88 -20 27
          -21 27 -161 30 l-140 3 -21 -44z m304 -70 c15 -40 15 -47 1 -80 l-15 -37 -126
          0 -126 0 -15 36 c-15 35 -13 58 8 102 11 21 17 22 134 22 l122 0 17 -43z"
      />
      <path
        d="M3141 2077 c-28 -58 -29 -155 -1 -212 19 -40 23 -43 73 -49 28 -3 89
          -6 134 -6 78 0 82 1 107 30 30 37 40 81 34 160 -3 40 -11 70 -25 88 -20 27
          -21 27 -161 30 l-140 3 -21 -44z m304 -70 c15 -40 15 -47 1 -80 l-15 -37 -126
          0 -126 0 -15 36 c-15 35 -13 58 8 102 11 21 17 22 134 22 l122 0 17 -43z"
      />
      <path
        d="M1976 1856 c-14 -29 -16 -67 -14 -238 4 -269 21 -271 29 -3 3 110 6
          201 7 203 1 1 91 1 200 0 l197 -3 9 -38 c6 -23 6 -48 0 -65 l-9 -27 -120 -2
          c-156 -4 -160 -5 -179 -53 -32 -81 -12 -203 36 -215 13 -3 86 -4 163 -3 l140
          3 0 30 0 30 -144 3 c-86 1 -150 7 -158 14 -7 6 -13 28 -13 48 0 71 -2 70 145
          70 166 0 168 1 173 130 3 66 0 95 -12 119 l-17 31 -208 0 -209 0 -16 -34z"
      />
      <path
        d="M2547 1774 c-4 -4 -7 -78 -7 -163 0 -213 -11 -201 184 -201 198 0
          190 -7 194 170 3 106 0 135 -14 165 l-17 36 -91 -3 -91 -3 0 -30 0 -30 85 -5
          85 -5 3 -38 3 -38 -153 3 -153 3 -3 65 c-3 63 -11 87 -25 74z m331 -251 l-3
          -38 -144 -3 c-156 -3 -161 -1 -161 51 l0 27 156 0 155 0 -3 -37z"
      />
      <path
        d="M1364 1685 c-3 -8 -4 -63 -2 -124 5 -161 -10 -152 257 -149 l216 3 0
          30 0 30 -210 3 c-183 2 -212 4 -222 19 -8 11 -13 51 -13 110 0 57 -4 93 -10
          93 -6 0 -13 -7 -16 -15z"
      />
      <path
        d="M3124 1685 c-3 -8 -4 -63 -2 -124 5 -161 -10 -152 257 -149 l216 3 0
          30 0 30 -210 3 c-183 2 -212 4 -222 19 -8 11 -13 51 -13 110 0 57 -4 93 -10
          93 -6 0 -13 -7 -16 -15z"
      />
    </g>
  </svg>`;

export const SIGNATURE_STAMP = makeSignatureStamp({});
